import { render, staticRenderFns } from "./RiepilogoPreventivi.vue?vue&type=template&id=6aa51a78&"
import script from "./RiepilogoPreventivi.vue?vue&type=script&lang=js&"
export * from "./RiepilogoPreventivi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports